export const DEFAULT_CALENDAR_FORMATS = {
  lastDay : '[Yesterday at] LT',
  sameDay : '[Today at] LT',
  nextDay: '[Tomorrow at] LT',
  lastWeek : 'Do MMM, YYYY [at] LT',
  nextWeek: 'Do MMM, YYYY [at] LT',
  sameElse: 'Do MMM, YYYY [at] LT'
};
